import { render, staticRenderFns } from "./FuelStockCreateMovement.vue?vue&type=template&id=60288530"
import script from "./FuelStockCreateMovement.vue?vue&type=script&lang=js"
export * from "./FuelStockCreateMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports